// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___Eej6F","root__main":"style-module__root__main___Iz2QO","root__desc":"style-module__root__desc___ZbqkG"};
    if(module.hot) {
      // 1697460475225
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  